/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React, {Component} from 'react';
import intl from 'react-intl-universal';

import OutageSeverityIndicator from "../isp/OutageSeverityIndicator";
import {getCountryName} from "../place/GeoCountries";

class OutagePlaceList extends Component {

    outage() {
        return this.props.outage;
    }

    dimension() {
        return this.props.dimension || 'City';
    }

    limit() {
        return this.props.limit || 5;
    }

    impactThreshold() {
        return this.props.impactThreshold || 65;
    }

    // --------------------------------------------------------------------------------

    render() {
        let outage = this.outage();
        const type = this.dimension();
        const limit = this.limit();

        if (type==='WideAreaImpact') {
            return this.props.compact ? this.renderCompactWideArea() : this.renderLongWideArea();
        }

        if (outage.topDrills === undefined)
            return '';

        let filter = outage.topDrills
            .filter(drill => (drill.dimName === type))
            .slice(0, limit);

        if (this.props.compact) {
            if (filter.length === 0) {
                return '';
            }
            return this.renderCompact(type, filter);
        } else {
            return this.renderLong(outage, filter);
        }
    }

    classForImpact(relativeImpact) {
        if (relativeImpact < 40) {
            return "text-secondary";
        } else if (relativeImpact < 80) {
            return "text-body";
        } else  {
            return "text-danger";
        }
    }

    // --------------------------------------------------------------------------------
    // Render COMPACT list
    // --------------------------------------------------------------------------------

    renderCompactWideArea() {
        const faIcon = 'fa-map';
        let item = this.outage();
        let name = item.mainDimensionRegionValue ? item.mainDimensionRegionValue : getCountryName(item.mainDimensionCountryValue);
        return (
            <div className="d-flex">
                <div className="flex-column p-0 m-0">
                    <small className={"fas fa-fw " + faIcon + " text-secondary align-middle mr-2"}/>
                </div>
                <div className="flex-column p-0 m-0">
                    <span className="align-middle small text-secondary">
                        <span>
                            <strong className="text-body">Whole {name}</strong>
                        </span>
                    </span>
                </div>
            </div>
        );
    }


    renderCompact(type, listOfDrills) {
        const faIcon = type === 'City' ? 'fa-building' : 'fa-map';
        return (
            <div className="d-flex">
                <div className="flex-column p-0 m-0">
                    <small className={"fas fa-fw " + faIcon + " text-secondary align-middle mr-2"}/>
                </div>
                <div className="flex-column p-0 m-0">
                    <span className="align-middle small text-secondary">
                        {listOfDrills.map((drill, index) => this.renderCompactDrill(drill, (index === listOfDrills.length - 1)))}
                    </span>
                </div>
            </div>
        );
    }

    renderCompactDrill(drill, isLast) {
        let separator = (isLast ? '' : ', ');
        if ((drill.finalSeverityNum*20) >= this.impactThreshold()) {
            return (<span>
                <strong className="text-body">{drill.dimValue}</strong>{separator}</span>
            );
        } else {
            return (<span>{drill.dimValue}{separator}</span>);
        }
    }

    // --------------------------------------------------------------------------------
    // Render LONG list
    // --------------------------------------------------------------------------------

    renderLongWideArea() {
        let item = this.outage();
        let relativeImpact = item.severityNum*20;
        let name = item.mainDimensionRegionValue ? item.mainDimensionRegionValue : getCountryName(item.mainDimensionCountryValue);
        return (
                <ul style={{listStyle: 'none'}} className="p-0">
                   <li className="small align-middle">
                       <span className="mr-2">{this.renderScore(relativeImpact)}</span>
                       <span className={this.classForImpact(relativeImpact)}>Whole {name}</span>
                   </li>
                </ul>
            );
    }

    renderLong(outage, listOfDrills) {
        if (!outage || !listOfDrills)
            return '';

        const maxLength = 5;
        const listId = 'place-list-' + new Date().getTime();

        if (listOfDrills.length > maxLength) {
            return (
                <ul style={{listStyle: 'none'}} className="p-0" >
                    {listOfDrills.slice(0, maxLength).map(drill => this.renderLongDrill(outage, drill))}
                    <div className="collapse" id={listId}>
                        {listOfDrills.slice(maxLength, this.limit()).map(drill => this.renderLongDrill(outage, drill))}
                    </div>
                    <a className="link link-collapse small font-size-1 collapsed mt-2"
                       data-toggle="collapse"
                       href={'#' + listId} role="button"
                       aria-expanded="false"
                       aria-controls={listId}>
                        <span className="link-collapse-default">{intl.get('generic_view_more')}</span>
                        <span className="link-collapse-active">{intl.get('generic_view_less')}</span>
                        <span className="link-icon ml-1">
                        <span className="link-icon-inner">+</span>
                    </span>
                    </a>
                </ul>
            );
        } else if (listOfDrills.length > 0) {
            return (
                <ul style={{listStyle: 'none'}} className="p-0">
                    {listOfDrills.map(drill => this.renderLongDrill(outage, drill))}
                </ul>
            );
        } else {
            return (
                <ul style={{listStyle: 'none'}} className="p-0">
                    <li className="small align-middle">
                        <span className={this.classForImpact(0)}>No area impacted</span>
                    </li>
                </ul>
            );
        }
    }

    renderLongDrill(outage, drill) {
        let relativeImpact = drill.finalSeverityNum*20;
        //let relativeImpact = drill.finalImpact;
        return (
            <li className="small align-middle">
                <span className="mr-2">{this.renderScore(relativeImpact)}</span>
                <span className={this.classForImpact(relativeImpact)}>{drill.dimValue}</span>
            </li>
        );
    }

    renderScore(relativeImpact) {
        return <OutageSeverityIndicator score={relativeImpact} />
    }

}

export default OutagePlaceList;